import { BsChevronRight } from "react-icons/bs";
import { Link } from "react-router-dom";
import styles from "./BreadCrumb.module.scss";

const BreadCrumb = ({ list }) => {
    return (
        <ul className={styles.breadcrumb}>
            {list.map((item, index) => {
                return (
                    <li key={index}>
                        <Link to={item.link ?? "/"}>{item.name}</Link>
                        {index === list.length - 1 ? null : (
                            <BsChevronRight color="#000" size={10} />
                        )}
                    </li>
                );
            })}
        </ul>
    );
};

export default BreadCrumb;
